import {
  LinkBoxProps,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import { PrimaryButton } from "components/Button";
import AddPathsForm from "features/PendingNewHire/Form/AddPathsForm";
import AddPathsButton from "../Button/NewPathButton";

interface AddPathsModalProps extends LinkBoxProps {
  newHireJourneyId: string;
}

export default function AddPathsModal({
  newHireJourneyId,
  children,
  ...rest
}: AddPathsModalProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      {children ? (
        React.cloneElement(children as JSX.Element, { onClick: onOpen, ...rest })
      ) : (
        <AddPathsButton onOpen={onOpen} {...rest} />
      )}

      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add Paths to New Hire</ModalHeader>
          <ModalBody>
            <AddPathsForm newHireJourneyId={newHireJourneyId} />
          </ModalBody>

          <ModalFooter>
            <PrimaryButton onClick={onClose}>
              Close
            </PrimaryButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
